module.exports = __webpack_public_path__ + "static/media/5_r_holst_64.32_92.31.fda235b5.png";